var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingOfficePerformanceSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dbe9fa;}.cls-2{fill:#d9dce1;}.cls-3{fill:#ffffff;}.cls-4{fill:#52acf9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": " performance",
    id: "_performance"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 14,
    width: 6,
    x: 2,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 19,
    width: 6,
    x: 11,
    y: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "23 1.4 16.92 9 20 9 20 30 26 30 26 9 29.08 9 23 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,30H8V16H2ZM4,18H6V28H4Zm7,12h6V11H11Zm2-17h2V28H13ZM23,1.4,16.92,9H20V30h6V9h3.08ZM24,7V28H22V7h-.92L23,4.6,24.92,7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingOfficePerformanceSvgrepoCom);
export default __webpack_public_path__ + "static/media/marketing-office-performance-svgrepo-com.17371a5b4fff9746cbe495cf11610bba.svg";
export { ForwardRef as ReactComponent };